import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export function normalizePhoneNumber(rawNumber: string | number | null): string {
  if (!rawNumber) return '';
  const numberAsString = rawNumber.toString();

  try {
    if (!numberAsString) return numberAsString;

    // Adiciona o + se não tiver
    const numberWithPlus = numberAsString.startsWith('+') ? numberAsString : `+${numberAsString}`;

    const phoneNumber = parsePhoneNumberFromString(numberWithPlus);

    if (!phoneNumber) return numberAsString;
    if (phoneNumber.country !== 'BR') return numberAsString;

    // Obtemos o número nacional (sem código do país)
    const countryCode = phoneNumber.countryCallingCode;

    if (phoneNumber?.getType() === 'FIXED_LINE') return numberAsString;
    if (phoneNumber?.nationalNumber?.length !== 10) return numberAsString;

    const areaCode = phoneNumber?.nationalNumber.slice(0, 2);
    const subscriber = phoneNumber?.nationalNumber.slice(2);
    const nationalNumber = `${areaCode}9${subscriber}`;
    const parsedNumber = `${countryCode}${nationalNumber}`;

    return parsedNumber;
  } catch (e) {
    return numberAsString;
  }
}
